import { Label, TextFont } from "../config/StyledComponents";

const InputLabel = ({
  label,
  isRounded,
  labelFontColor,
  labelFontSize,
  labelFontWeight,
  required,
}) => {
  return (
    label && (
      <Label isRounded={isRounded}>
        <TextFont
          fontColor={labelFontColor}
          fontSize={labelFontSize}
          fontWeight={labelFontWeight}
        >
          {label}
          {required && <span>*</span>}
        </TextFont>
      </Label>
    )
  );
};

export default InputLabel;
